import { supabase } from './supabase';

// Captured at load, before Supabase tidies up the URL.
const hash = window.location.hash;
let active = window.location.pathname === '/reset-password' || hash.includes('type=recovery');

/** True if we arrived from a reset link that Supabase rejected (expired/used). */
export const recoveryLinkError = hash.includes('error=');

const listeners = new Set<() => void>();
const emit = () => listeners.forEach((fn) => fn());

// Supabase fires this while starting up from a reset link, before any
// component mounts, so the listener has to live here at module load.
supabase.auth.onAuthStateChange((event) => {
  if (event === 'PASSWORD_RECOVERY' && !active) { active = true; emit(); }
});

export const recoveryStore = {
  subscribe(fn: () => void) { listeners.add(fn); return () => { listeners.delete(fn); }; },
  getSnapshot: () => active,
  /** Call just before verifying a reset code, so the session it creates opens
   *  the "Set a new password" screen instead of the dashboard. */
  arm() { active = true; },
  /** The code was wrong: undo arm(). */
  disarm() { active = false; },
  /** Reset finished or abandoned. */
  clear() { active = false; emit(); },
};